import React from 'react';
import { DealershipUserV1, CeDealershipV1 } from '../../services/dealerships/types';
import { Avatar } from 'lynkco-up-core';

interface OwnerCardProps {
  dealership: CeDealershipV1 | undefined;
  onOwnerSelect?: (user: DealershipUserV1, id: string) => void;
}
const OwnerCard: React.FC<OwnerCardProps> = ({ dealership, onOwnerSelect }) => {
  const handleUserClick = (user: DealershipUserV1, id: string) => {
    if (onOwnerSelect) {
      onOwnerSelect(user, id); // Notify parent
    }
  };
  if (
    dealership == undefined ||
    dealership.owner === undefined ||
    dealership.owner.firstName == '' ||
    dealership.owner.email == '' ||
    dealership.owner.id == ''
  ) {
    return <div />;
  }

  return (
    <div className="mb-10">
      <h3 className="font-medium text-xl mb-2">Owner/Admin</h3>
      <div
        onClick={() => handleUserClick(dealership.owner ?? {}, dealership.id ?? '')}
        className="flex center items-stretch border border-black rounded-lg p-4 max-w-md bg-white">
        <div className="flex flex-row align-center">
          <Avatar
            size="extraLarge"
            src={dealership.owner.urlProfilePicture ?? ''}
            alt={dealership.owner.firstName ?? ''}
            extraClasses="my-auto mr-4"></Avatar>
          <div className="flex flex-col">
            <div className="text-lg text-xl font-bold">{dealership.owner.firstName}</div>
            <div>{dealership.owner.email}</div>
            <div>User ID: {dealership.owner.id}</div>
          </div>
        </div>
      </div>{' '}
    </div>
  );
};

export default OwnerCard;
